var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.598 11.6775C25.6922 11.8052 25.8415 11.8805 26.0002 11.8805C26.1588 11.8805 26.3081 11.8052 26.4024 11.6775C28.5011 8.8357 31.8649 7 35.6202 7C41.9907 7 47.1668 12.2181 47.1668 18.6794C47.1668 24.5972 44.0841 29.8396 40.2061 34.0884C36.3324 38.3324 31.7136 41.5309 28.7554 43.3515C27.8352 43.9178 27.4507 44.1493 26.8392 44.2864C26.3845 44.3885 25.6158 44.3885 25.1611 44.2864C24.5496 44.1493 24.1651 43.9178 23.2449 43.3515C20.2867 41.5309 15.6679 38.3324 11.7942 34.0884C7.91625 29.8396 4.8335 24.5972 4.8335 18.6794C4.8335 12.2181 10.0096 7 16.3802 7C20.1566 7 23.4989 8.83529 25.598 11.6775Z",
    fill: "url(#paint0_linear_48_340)",
    stroke: "url(#paint1_linear_48_340)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_48_340",
    x1: 26.0002,
    y1: 6.5,
    x2: 26.0002,
    y2: 44.8629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4BFFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D9997"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_48_340",
    x1: 26.0002,
    y1: 44.8629,
    x2: 26.0002,
    y2: 6.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.0bb15c96375c856d8eec8ab3f30106c2.svg";
export { ForwardRef as ReactComponent };